<template>
    <footer class="site-footer">
        <div class="footer-container">

            <!-- SECCIÓN SUPERIOR: ENLACES Y CONTACTO -->
            <div class="footer-columns">

                <!-- Columna: Particular -->
                <div class="footer-column">
                    <h4 class="column-title">Particular</h4>
                    <nav class="column-links">
                        <a href="https://www.zeleris.com">Seguimiento de envíos</a>
                        <a href="https://www.zeleris.com">Resolución de conflictos</a>
                    </nav>
                </div>

                <!-- Columna: Empresas -->
                <div class="footer-column">
                    <h4 class="column-title">Empresas</h4>
                    <nav class="column-links">
                        <a href="https://www.zeleris.com">Transporte nacional</a>
                        <a href="https://www.zeleris.com">Transporte internacional</a>
                        <a href="https://www.zeleris.com">Logística</a>
                        <a href="https://www.zeleris.com">Servicio técnico</a>
                        <a href="https://www.zeleris.com">Economía Circular</a>
                        <a href="https://www.zeleris.com">Mayorista</a>
                        <a href="https://www.zeleris.com">E-Commerce</a>
                    </nav>
                </div>

                <!-- Columna: Sobre Zeleris -->
                <div class="footer-column">
                    <h4 class="column-title">Sobre Zeleris</h4>
                    <nav class="column-links">
                        <a href="https://www.zeleris.com">Sobre nosotros</a>
                        <a href="https://www.zeleris.com">Nuestra trayectoria</a>
                        <a href="https://www.zeleris.com">Soluciones por sectores</a>
                        <a href="https://www.zeleris.com">Responsabilidad corporativa</a>
                        <a href="https://www.zeleris.com">Sala de prensa</a>
                        <a href="https://www.zeleris.com">Trabaja con nosotros</a>
                    </nav>
                </div>

                <!-- Columna: Centro de Ayuda -->
                <div class="footer-column">
                    <h4 class="column-title">Centro de ayuda</h4>
                    <nav class="column-links">
                        <a href="https://www.zeleris.com">Preguntas frecuentes</a>
                        <a href="https://www.zeleris.com">Contacta con nosotros</a>
                        <a href="https://www.zeleris.com">Cita comercial</a>
                    </nav>
                </div>

                <!-- Columna: Redes y Datos Fiscales -->
                <div class="footer-column contact-column">
                    <h4 class="column-title">Síguenos en:</h4>
                    <div class="social-icons">
                        <!-- Facebook (f) -->
                        <a href="https://facebook.com" class="social-icon" target="_blank" rel="noopener" aria-label="Facebook">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                                <circle cx="18" cy="18" r="18" fill="#ffffff" />
                                <text x="18" y="24" font-family="Arial, Helvetica, sans-serif" font-weight="700" font-size="20" fill="#212121" text-anchor="middle">f</text>
                            </svg>
                        </a>
                        <!-- LinkedIn (in) -->
                        <a href="https://linkedin.com" class="social-icon" target="_blank" rel="noopener" aria-label="LinkedIn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                                <circle cx="18" cy="18" r="18" fill="#ffffff" />
                                <text x="18" y="23" font-family="Arial, Helvetica, sans-serif" font-weight="700" font-size="15" fill="#212121" text-anchor="middle" letter-spacing="-0.5">in</text>
                            </svg>
                        </a>
                        <!-- X (Twitter) -->
                        <a href="https://x.com" class="social-icon" target="_blank" rel="noopener" aria-label="X">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                                <circle cx="18" cy="18" r="18" fill="#ffffff" />
                                <path d="M12.5 10h2.6l4.2 5.7 4.5-5.7h2.7l-5.9 7.4 6.4 8.6h-2.6l-4.7-6.3-4.9 6.3h-2.7l6.3-8.1L12.5 10zm3 1.8l6.3 8.6h1.3l-6.3-8.6h-1.3z" fill="#212121" />
                            </svg>
                        </a>
                    </div>

                    <div class="contact-details">
                        <p class="contact-title">Contacta con nosotros:</p>
                        <p class="contact-phone">(+34) 91 707 40 01 – 900 100 136</p>
                        <p class="contact-schedule">Horario de lunes a viernes de 9:00h a 19:00h</p>

                        <div class="company-fiscal-data">
                            <p><strong>Telefónica Servicios Integrales de Distribución S.A.U. – N.I.F.: A82261280</strong></p>
                            <p>Domicilio social: C/ Gran Vía 28, 28013 Madrid. Inscripción en el Registro Mercantil de MADRID: Tomo 35.061, folio 47, Sección 8, Hoja m-223345</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- DIV DE POLÍTICAS Y COPYRIGHT CON EL COLOR GRIS EXACTO -->
        <div class="footer-middle-bar">
            <div class="footer-container middle-bar-content">
                <div class="bottom-links">
                    <a href="https://www.zeleris.com">Política de cookies</a>
                    <a href="https://www.zeleris.com">Política de privacidad</a>
                    <a href="https://www.zeleris.com">Mapa web</a>
                </div>
                <div class="copyright">
                    <p>© Zeleris – Telefónica Servicios Integrales de Distribución S.A.U</p>
                </div>
            </div>
        </div>

        <!-- DIV VERDE LIMA DE TELEFÓNICA -->
        <div class="footer-green-bar">
            <div class="green-bar-content">
                <span class="brand-text">Una compañía de</span>
                <svg class="telefonica-logo-svg" viewBox="0 0 260 40" height="26" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#000000">
                        <circle cx="6" cy="6" r="5" />
                        <circle cx="18" cy="6" r="5" />
                        <circle cx="30" cy="6" r="5" />
                        <circle cx="18" cy="18" r="5" />
                        <circle cx="18" cy="30" r="5" />
                    </g>
                    <text x="44" y="27" font-family="'Heebo', Arial, sans-serif" font-weight="700" font-size="25" fill="#000000" letter-spacing="-0.5">Telefónica</text>
                </svg>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'NewPie'
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Heebo:wght@300;400;500;600;700&display=swap');

    /* FONDO PRINCIPAL: NEGRO CARBÓN EXACTO */
    .site-footer {
        background-color: #212121;
        font-family: 'Heebo', sans-serif;
        padding-top: 40px;
        color: #ffffff;
    }

    .footer-container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }

    .footer-columns {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 30px;
        padding-bottom: 35px;
    }

    .footer-column {
        flex: 1;
        min-width: 150px;
    }

    .contact-column {
        flex: 1.8;
        min-width: 280px;
        border-left: 1px solid #3d3d3d; /* Separador sutil exacto */
        padding-left: 28px;
    }

    .column-title {
        font-size: 15px;
        font-weight: 700;
        margin: 0 0 16px 0;
        color: #ffffff;
    }

    .column-links {
        display: flex;
        flex-direction: column;
        gap: 9px;
    }

        .column-links a {
            color: #ffffff;
            text-decoration: none;
            font-size: 13.5px;
            line-height: 1.35;
            opacity: 0.92;
        }

            .column-links a:hover {
                text-decoration: underline;
                opacity: 1;
            }

    /* REDES SOCIALES */
    .social-icons {
        display: flex;
        gap: 10px;
        margin-bottom: 18px;
    }

    .social-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        transition: opacity 0.2s ease;
    }

        .social-icon:hover {
            opacity: 0.85;
        }

        .social-icon svg {
            display: block;
        }

    /* CONTACTO Y DATOS FISCALES */
    .contact-details {
        font-size: 12.5px;
        color: #d1d1d1;
        line-height: 1.45;
    }

    .contact-title {
        font-weight: 700;
        color: #ffffff;
        margin: 0 0 5px 0;
    }

    .contact-phone {
        margin: 0 0 4px 0;
        color: #ffffff;
        font-weight: 500;
    }

    .contact-schedule {
        margin: 0 0 16px 0;
        color: #b5b5b5;
        font-size: 12px;
    }

    .company-fiscal-data {
        font-size: 11px;
        color: #a0a0a0;
        line-height: 1.4;
    }

        .company-fiscal-data p {
            margin: 0 0 4px 0;
        }

    /* FRANJA INTERMEDIA GRIS: TONE GRIS OSCURO ANTRACITA (#2B2B2B) */
    .footer-middle-bar {
        background-color: #4d5151;
        padding: 14px 0;
    }

    .middle-bar-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 15px;
    }

    .bottom-links {
        display: flex;
        gap: 22px;
    }

        .bottom-links a {
            color: #ffffff;
            text-decoration: none;
            font-size: 12.5px;
            opacity: 0.9;
        }

            .bottom-links a:hover {
                text-decoration: underline;
                opacity: 1;
            }

    .copyright p {
        margin: 0;
        font-size: 12.5px;
        color: #b5b5b5;
    }

    /* FRANJA VERDE LIMA */
    .footer-green-bar {
        background-color: #a6ed00;
        padding: 10px 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .green-bar-content {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
    }

    .brand-text {
        font-size: 13.5px;
        color: #000000;
        font-weight: 600;
    }

    .telefonica-logo-svg {
        display: block;
    }

    /* RESPONSIVO */
    @media (max-width: 900px) {
        .contact-column {
            border-left: none;
            padding-left: 0;
        }
    }

    @media (max-width: 600px) {
        .footer-columns {
            flex-direction: column;
            gap: 22px;
        }

        .middle-bar-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .bottom-links {
            flex-direction: column;
            gap: 8px;
        }
    }
</style>